import React from 'react';
import { hotelData } from '../data/hotelData';
import { Tag, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Offers = () => {
  return (
    <section className="section-padding bg-luxury-beige/30">
      <div className="container-custom">
        <div className="flex flex-col items-center justify-center text-center mb-16">
          <span className="subheading-premium">
            Exclusive Deals
          </span>
          <h2 className="heading-premium">Limited Time Offers</h2>
          <button className="text-orange-500 font-bold tracking-[2px] uppercase text-xs flex items-center gap-2 group mt-4">
            View All
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {hotelData.offers.map((offer, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="glass-card overflow-hidden flex flex-col sm:flex-row h-full group"
            >
              <div className="sm:w-1/2 relative overflow-hidden">
                <img 
                  src={offer.image} 
                  alt={offer.title} 
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
              </div>
              <div className="sm:w-1/2 p-8 flex flex-col justify-center items-start">
                <span className="flex items-center gap-2 text-orange-500 font-bold text-[10px] tracking-widest uppercase mb-4 bg-orange-50 px-4 py-2 rounded-sm border border-orange-200">
                  <Tag className="w-3 h-3" />
                  {offer.badge}
                </span>
                <h3 className="text-2xl font-serif text-luxury-black mb-3 leading-tight">{offer.title}</h3>
                <p className="text-gray-500 mb-8 font-light tracking-wide">{offer.discount}</p>
                <button className="btn-outline !py-2 !px-8 text-xs bg-white">
                  Grab Offer
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;
